module.exports = __webpack_public_path__ + "img/dynamic-11.f4a73fda.png";